
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M445.771 238.813L264.438 4.146C262.419 1.534 259.215.003 256.01 0c-3.211-.003-6.424 1.529-8.447 4.146L66.229 238.813a10.656 10.656 0 00-1.135 11.219 10.653 10.653 0 009.573 5.969h96v245.333a10.66 10.66 0 0010.667 10.667h149.333a10.66 10.66 0 0010.667-10.667V256h96c4.073 0 7.781-2.313 9.573-5.969 1.791-3.646 1.353-8-1.136-11.218z"}})])
          )
        }
      }
    